import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button, ButtonBar } from '../components';

import { LifeDocumentIntroHeader, LifeDocumentIntroSection } from './will-page';

const sections = [
  {
    icon: 'alarm',
    title: 'Time Required',
    content: '15 minutes',
    subText: 'You can save your progress and return later.'
  },
  {
    icon: 'format_list_numbered',
    title: 'Steps',
    content: '6',
    subText: 'Simple guided steps'
  }
];

export default function HealthcareDirectivesPage() {
  const navigate = useNavigate();
  
  const handleNext = useCallback(() => {
    // Navigate to the new healthcare directive creation page
    navigate('new');
  }, [ navigate ]);

  return (
    <div className="healthcare-directive-page">
      <LifeDocumentIntroHeader
        icon="description"
        title="Welcome to the healthcare directive process"
        description="This guided process will help you create a healthcare directive in just a few simple steps."
      />
      <div className="life-document-intro-sections">
        {
          sections.map((section, index) => (
            <LifeDocumentIntroSection
              key={index}
              icon={section.icon}
              title={section.title}
              content={section.content}
              subText={section.subText}
            />
          ))
        }
      </div>
      {/* TODO: bigger buttons */}
      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}

